import { CSSProperties } from 'react';
import { Column, Row, Text } from '~/commonComponents';
import { getShouldUseAttestaion } from '~/growthbook';
import CheckCircleBlue from '~/images/check-circle-blue.svg';
import { IUserConsent } from '~/models';

interface IProps {
  consent?: IUserConsent;
  style?: CSSProperties;
}

export const ProfessionalAttestationInfo = ({ consent, style }: IProps) => {
  if (!getShouldUseAttestaion() || !consent?.is_consented) {
    return <></>;
  }

  return (
    <Column justifyContent="center" alignItems="center" style={style}>
      {consent?.consented_requirements?.map((item) => (
        <Row
          key={item.key}
          backgroundColor={'#E5F3FB'}
          justifyContent="center"
          alignItems="center"
          borderRadius={8}
          paddingHorizontal={15}
          paddingVertical={5}
          gap={6}
        >
          <img src={CheckCircleBlue} style={{ height: 24, width: 24 }} alt="" />
          <Text bold>{item.value} Complete</Text>
        </Row>
      ))}
    </Column>
  );
};
